import { useTranslation } from "react-i18next"

import { useAgentState } from "@/agent-state"
import { MultiCombobox } from "@/components/ui/multi-combobox"
import { LoadingFilter } from "@/pages/Campaigns/pickers/generic-filter-picker"

type Props = {
  allowReset?: boolean
  onChange: (values: string[]) => void
  values: string[]
}

export function AgentCampaignPicker({ allowReset, onChange, values }: Props) {
  const { t } = useTranslation()
  const { state } = useAgentState()
  const campaignIds = state.context.agentProfile?.campaigns || []

  const options =
    campaignIds.map((campaignId) => ({
      value: campaignId,
      label: campaignId,
    })) || []

  if (!campaignIds.length) {
    return <LoadingFilter />
  }

  return (
    <MultiCombobox
      allowReset={allowReset}
      values={values}
      onChange={onChange}
      options={options}
      placeholder={t("missedCalls.filterPlaceholder")}
      size="md"
    />
  )
}
